<template>
  <!--    '请输入' +
          (assignItemOptions.label ? (assignItemOptions.placeholder?assignItemOptions.placeholder:assignItemOptions.label) : '搜索内容') -->
  <span>
    <template
      v-if="
        ['text', 'textarea', 'email', 'icon'].indexOf(
          assignItemOptions.type
        ) !== -1
      "
    >
      <el-input
        :class="'input ' + (assignItemOptions.noBorder ? 'noBorder' : '')"
        :style="'width:' + assignItemOptions.queryWidth + 'px;'"
        :placeholder="
          assignItemOptions.placeholder
            ? assignItemOptions.placeholder
            : '请输入' + assignItemOptions.label
        "
        v-model="inputValue"
        filterable
        inline-message
        @focus="handleFocus"
        @input="handleInput"
        :readonly="assignItemOptions.readonly"
        :disabled="assignItemOptions.disabled"
        :type="assignItemOptions.type"
        :show-password="assignItemOptions.showPassword"
      >
        <!-- <template #append><slot name="append"></slot></template> -->
        <template v-if="assignItemOptions.type == 'icon'" #append>
          <span class="icon-show-span">
            <i :class="'icon ' + inputValue"></i>
          </span>
          <el-popover
            placement="bottom-end"
            width="250"
            v-model="popoverVisiable"
          >
            <div class="icon-container">
              <span
                v-for="(item, index) in fontArr"
                @click="chooseIcon(item)"
                :key="index"
                class="icon-container-item"
                ><i :class="'icon ' + item.name"></i
              ></span>
            </div>
            <el-button
              slot="reference"
              class="icon icon-icon-arrow-down"
            ></el-button>
          </el-popover>
        </template>
      </el-input>
    </template>
    <template v-if="assignItemOptions.type === 'color'">
      <el-color-picker
        class="input"
        @input="handleInput"
        @change="handleInput"
        v-model="inputValue"
      ></el-color-picker>
    </template>

    <template v-if="assignItemOptions.type === 'number'">
      <el-input-number
        class="input"
        v-model="inputValue"
        controls-position="right"
        @input="handleInput"
        @change="handleInput"
        :min="1"
      ></el-input-number>
    </template>

    <template v-if="assignItemOptions.type === 'switch'">
      <el-switch
        v-model="inputValue"
        @input="handleInput"
        :readonly="assignItemOptions.readonly"
        :disabled="assignItemOptions.disabled"
        :type="assignItemOptions.type"
      >
      </el-switch>
    </template>
    <template v-if="assignItemOptions.type === 'select'">
      <el-select
        :clearable="assignItemOptions.clearable"
        :style="'width:' + assignItemOptions.queryWidth + 'px'"
        :placeholder="'请选择' + assignItemOptions.label"
        v-model="inputValue"
        filterable
        @change="handleInput"
        :readonly="assignItemOptions.readonly"
        :disabled="assignItemOptions.disabled"
        :multiple="assignItemOptions.multiple"
        :collapse-tags="
          assignItemOptions.collapseTags === true ||
          assignItemOptions.collapseTags === false
            ? assignItemOptions.collapseTags
            : assignItemOptions.multiple
        "
      >
        <el-option
          v-for="(k, i) in assignItemOptions.options"
          :key="k ? k.Value : ''"
          :readonly="k.readonly"
          :disabled="k.disabled"
          :value-id="k.id"
          :label="
            assignItemOptions.dicLabel ? k[assignItemOptions.dicLabel] : k.Name
          "
          :value="
            assignItemOptions.dicValue ? k[assignItemOptions.dicValue] : k.Value
          "
        >
          <span v-if="assignItemOptions.iconSlot" :data-index="i"
            ><i :class="'icon ' + k.icon"></i> {{ k.Name }}</span
          >
        </el-option>
      </el-select>
    </template>
    <!--datetimerange,datetime -->
    <template
      v-if="
        [
          'year',
          'month',
          'date',
          'dates',
          'week',
          'datetime',
          'datetimerange',
          'daterange',
          'monthrange',
        ].indexOf(assignItemOptions.type) !== -1
      "
    >
      <el-date-picker
        v-model="inputValue"
        :type="assignItemOptions.type"
        @change="handleInput"
        :readonly="assignItemOptions.readonly"
        :disabled="assignItemOptions.disabled"
        :value-format="assignItemOptions.valueFormat"
        :format="assignItemOptions.format"
        placeholder="选择日期时间"
      >
      </el-date-picker>
    </template>
    <template v-if="assignItemOptions.type === 'checkbox'">
      <el-checkbox-group @change="handleInput" v-model="checkboxGroupValue">
        <el-checkbox-button
          v-for="(k, i) in assignItemOptions.options"
          :key="i"
          :label="
            assignItemOptions.dicValue ? k[assignItemOptions.dicValue] : k.Value
          "
          >{{
            assignItemOptions.dicLabel ? k[assignItemOptions.dicLabel] : k.Name
          }}</el-checkbox-button
        >
      </el-checkbox-group>
    </template>
    <template v-if="assignItemOptions.type === 'radio'">
      <el-radio-group @change="handleInput" v-model="inputValue" :readonly="assignItemOptions.readonly" :disabled="assignItemOptions.disabled" >
        <el-radio-button
          :key="i"
          v-for="(k, i) in assignItemOptions.options"
          :label="
            assignItemOptions.dicValue ? k[assignItemOptions.dicValue] : k.Value
          "
          :readonly="k.readonly"
          :disabled="k.disabled"
          >{{
            assignItemOptions.dicLabel ? k[assignItemOptions.dicLabel] : k.Name
          }}</el-radio-button
        >
      </el-radio-group>
    </template>
  </span>
</template>

<script>
import { getDic, getSelectData } from "./api";
import fontArr from "./font";
export default {
  name: "lrInput",
  props: {
    itemOptions: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Array | String,
      default: "",
    },
    inputType: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      inputValue: "",
      checkboxGroupValue: [],
      multipleValue: "",
      popoverVisiable: false,
      fontArr: [],
    };
  },
  computed: {
    //props的特性，它只在没有传参时才会被读取，并不会为你的参数对象补齐属性,所以用计算属性获取
    assignItemOptions() {
      return Object.assign(
        {
          readonly: false,
          disabled: false,
          multiple: false,
          showPassword: false,
          clearable: true,
          type: "text",
          queryWidth: "auto",
        },
        this.itemOptions
      );
    },
    /*inputValue(){
      return this.value;
    }*/
  },
  watch: {
    value: {
      handler: function (n, o) {
        if (this.assignItemOptions.type === "checkbox") {
          this.checkboxGroupValue = n;
        } else if (
          this.assignItemOptions.multiple &&
          this.assignItemOptions.type === "select"
        ) {
          this.inputValue = n ? n : [];
          if (this.inputValue.length === 0) {
            this.multipleValue = "";
          }
        } else {
          this.inputValue = n;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.inputValue = this.value;
    if (this.assignItemOptions.type === "icon") {
      this.fontArr = fontArr;
    }
    if (
      this.inputValue === "" ||
      (this.inputValue === [] &&
        (this.assignItemOptions.default ||
          this.assignItemOptions.default === false))
    ) {
      this.inputValue = this.assignItemOptions.default;
      if (this.assignItemOptions.field === "Gender") {
      }
      this.checkboxGroupValue = this.assignItemOptions.default;
      this.$emit("input", this.inputValue); // 这儿必须用input 发送数据
      this.$emit("handleInput", this.inputValue, this.assignItemOptions.field);
    }
    if (
      this.assignItemOptions.dicId !== "undefined" &&
      typeof this.assignItemOptions.projectUrl !== "undefined"
    ) {
      this.loadData();
    }
    if (this.assignItemOptions.requstOptions&&this.assignItemOptions.requstOptions.url) {
    this.loadData(2); }
    if (this.assignItemOptions.type === "switch") {
      this.inputValue = this.inputValue ? true : false;
    }
  },
  methods: {
    chooseIcon(item) {
      this.inputValue = item.name;
      this.$emit("handleInput", this.inputValue, this.assignItemOptions.field);
      this.popoverVisiable = false;
    },

    loadData(type = 1) {
      if (type == 1) {
        getDic(
          Object.assign({
            dicId: this.assignItemOptions.dicId,
            projectUrl: this.assignItemOptions.projectUrl,
          })
        ) //PublicParams,
          .then((res) => {
            if (res.Code === 200) {
              this.$set(this.itemOptions, "options", res.Data);
            }
          })
          .catch((error) => {});
      } else {
        getSelectData(this.assignItemOptions.requstOptions) //PublicParams,
          .then((res) => {
            if (res.Code === 200) {
              this.$set(this.itemOptions, "options", res.Data);
            }
          })
          .catch((error) => {});
      }
    },
    handleFocus() {
      if (typeof this.assignItemOptions.focus === "function") {
        this.assignItemOptions.focus(
          this.inputValue,
          this.assignItemOptions.field
        );
      }
    },
    handleInput() {
      if (this.assignItemOptions.type === "checkbox") {
        this.inputValue = this.checkboxGroupValue;
      }
      let optionItem = '';
      if(this.assignItemOptions.options){
        this.assignItemOptions.options.map((item,index)=>{
          if((this.assignItemOptions.dicValue ? item[this.assignItemOptions.dicValue] : item.Value)==this.inputValue){
            optionItem = item;
          }
        })
      }
      this.$emit("input", this.inputValue,optionItem); // 这儿必须用input 发送数据
      this.$emit("handleInput", this.inputValue, this.assignItemOptions.field);
      if (typeof this.assignItemOptions.callback === "function") {
        this.assignItemOptions.callback(
          this.inputValue,
          this.assignItemOptions.field,
          optionItem
        );
      }
      if (this.assignItemOptions.multiple) {
        this.multipleValue = this.inputValue.join(",");
      }
    },
  },
};
</script>

<style scoped  lang="scss">
.noBorder {
  /deep/ input {
    border: none !important;
  }
}
>>> .el-input-number {
  width: 100% !important;
}
>>> .el-input--mini .el-input__inner {
  // height:28px!important;
}

>>> .el-input-group {
  font-size: 14px !important;
}
>>> .el-input-group__append {
  font-size: 22px;
  padding: 0px 10px;
}
.icon-show-span {
  min-width: 22px;
  display: inline-block;
  height: 100%;
  button {
    cursor: initial;
  }
}
.icon-container {
  &-item:hover {
    background: rgb(238, 238, 238);
  }
  &-item {
    float: left;
    padding: 7px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LrInput/index.vue